import React, { useState, useEffect } from "react";
import { TextField } from "@arctheme-components/elements/TextField/TextField";
import { LoadingSpinner } from "@arctheme-components/elements/LoadingSpinner/LoadingSpinner";
import { CartActions } from "./MinicartActions/MinicartActions";
import { CartItems } from "./MinicartItems/MinicartItems";
import { CartTitle } from "./MinicartTitle/MinicartTitle";
import { CartTotals } from "./MinicartTotals/MinicartTotals";
import useCartData from "@arctheme-hooks/useCartData";
import useHeaderMenuStore from '@src/stores/HeaderMenuStore';
import { useHeaderHeight } from '@src/hooks/useHeaderHeight';
import useMobileBreakpoint from "@arctheme-hooks/useMobileBreakpoint";
import { mobileBreakpoint } from "../../../../entrypoints/theme";


export const Minicart = ({ cartData, style = "drawer", props }) => {
  const {cart, fetchCart}: any = useCartData();
  const {section} = props;
  const isMobile = useMobileBreakpoint(mobileBreakpoint);

  const showCartCountAtTop = section.show_cart_item_count;
  const showMinicartTitle = section.show_minicart_title;
  const { currentMenu } = useHeaderMenuStore();
  const openMenu = useHeaderMenuStore((state) => state.openMenu)
  const closeMenu = useHeaderMenuStore((state) => state.closeMenu)
  const openMiniCart = (event) => {

      const {requestState, cart, previousCart, sections} = event.detail;

      if (requestState.requestType === "add") {
          if (requestState.responseData?.ok) {
              openMenu('CART', isMobile);
          }
      }
  }

  useEffect(() => {
      document.addEventListener("liquid-ajax-cart:request-end", openMiniCart);
      return () => {
          removeEventListener("liquid-ajax-cart:request-end", openMiniCart);
      };
  }, []);

  const { height, headerHeight } = useHeaderHeight();

  return (
    <>
      <div className={`minicart-overlay ${currentMenu === "CART" ? "" : "hidden"}`}></div>
      <div
        className={`minicart-wrapper ${style} relative ${currentMenu === "CART" ? "" : "hidden"}`}
        style={{
          height: isMobile ? null : height,
          top: isMobile ? headerHeight : null
        }}
        x-cloak="true"
        x-transition:enter="transition ease-out duration-300"
        x-transition:enter-start="off-screen-right"
        x-transition:enter-end="right-50"
        x-transition:leave="transition ease-in duration-300"
        x-transition:leave-start="right-50"
        x-transition:leave-end="off-screen-right"
        // x-show="$store.global.isMinicartVisible"
      >
        <div className={`minicart w-full pt-[${section.padding_top_mobile}px] lg:pt-[${section.padding_top_desktop}px] pb-[${section.padding_bottom_mobile}px] lg:pb-[${section.padding_bottom_desktop}px] px-[${section.padding_left_right_mobile}px] lg:px-[${section.padding_left_right_desktop}px]`}>
          <button
            className="minicart__close"
            // x-on:click="$store.global.isMinicartVisible = false"
            onClick={() => closeMenu(isMobile)}
          >
            <span className="icon icon-close"></span>
            <span className="h6">CLOSE</span>
          </button>
          <LoadingSpinner id={"cart-spinner"} />
          {showMinicartTitle &&
            <div className="flex-none">
              <CartTitle item_count={cart?.item_count} />
              {showCartCountAtTop && <CartCount item_count={cart?.item_count} />}
            </div>
          }
          <div className="flex-1 overflow-y-auto">
            <CartItems
                settings={section}
                items={cart?.items}
                show_vendor={false}
                show_total_price={section.show_total_price}
            />

            {cart?.items?.length <= 0 && (
              <div
                className={
                  "flex flex-col gap-y-[16px] text-center h-full justify-center p-[16px]"
                }
              >
                <div className={"b4"}>
                  {section.empty_text_one}
                  <br />
                  {section.empty_text_two}
                </div>
                <a
                  x-on:click="$store.global.closeMinicart()"
                    onClick={() => closeMenu(isMobile)}
                  className={"minicart-empty__button button button-secondary"}
                >
                  {section.empty_button}
                </a>
              </div>
            )}
          </div>
          {cart?.items.length > 0 && (
            <div
              className={"minicart__bottom"}
            >
              <CartTotals
                cart_subtotal={cart?.items_subtotal_price / 100}
                cart_items={cart?.items}
                settings={props}
              />
              {/*<CartNotes show={true}/>*/}
              <CartActions show_cart={true} />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

const CartCount = ({ item_count }) => {
  return (
    <div className="item-count-message b2 p-[24px] flex gap-x-[8px]">
      <span className={"b-characteristics"}>Total Items</span>
      <span className="b-characteristics">{item_count}</span>
    </div>
  );
};

const CartNotes = ({ show = false }) => {
  return (
    <>
      <div className="cart_notes">
        <TextField
          type={"floating-input"}
          placeholder={"Enter notes for cart"}
          id={"cart_note"}
          value={undefined}
        />
      </div>
    </>
  );
};
